import React from 'react';
import {
  initLock,
  showLock
} from '../../common/auth0LockHelpers';


class CoachGrantAccess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: null,
      isLoading: null
    };
  }

  componentWillMount() {
    this.initiateLock();
  }

  componentDidMount() {
    if(window.location.hash) {
      this.resumeAuth();
    } else {
      this.handleShowLock();
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.athleteAccessResponse !== this.props.athleteAccessResponse){
      this.setState({ isLoading: false })
    }
  }

  initiateLock = () => {
    this.lock = initLock({
      container: 'auth0-login-container'
    });
  };

  handleShowLock = () => {
    // override state to make sure redirection url is up-to-date
    showLock(this.lock);
  };

  resumeAuth = () => {
    this.lock.resumeAuth(window.location.hash, (err, auth) => {
      if(!err && auth && auth.idToken) {
        sessionStorage.setItem('idToken', auth.idToken);
        sessionStorage.setItem('accessToken', auth.accessToken);

        this.setState({
          // note profile info such as email and user_id etc are not included in auth
          metadata: auth.idTokenPayload.app_metadata,
          idToken: auth.idToken
        });

        console.log('lock.resumeAuth Authenticated!');
        this.onAuthenticated(auth.accessToken);
      }

      if(err){
        console.error('lock.resumeAuth err', err);
        return;
      }
    });
  };

  onAuthenticated = (accessToken) => {
    this.lock.getUserInfo(accessToken, (err, profile) => {
      if(err){
        console.error('lock.getUserInfo err', err);
        return;
      }

      console.log('lock.getUserInfo Profile Retrieved', profile)
      this.setState({ profile, isLoading: true });

      const accessCode = this.getQueryVariable('accessCode');
      this.props.actions.signUpActions.athleteUseAccessCode(accessCode, profile);
    })
  }

  getQueryVariable= (key) => {
    var query = window.location.search.substring(1);
    var result = null;
    var vars = query.split('&');
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split('=');
      if(pair[0] == key){
        result = pair[1];
        return pair[1];
      }
    }
    return result;
  }

  openNewTab = (destination) => {
    if(destination === 'appStore'){
      window.open('https://itunes.apple.com/us/app/trybe-crossfit-wod-and-log-tracker-with-timer/id1100080003?mt=8', '_blank')
    } else {
      window.open('https://play.google.com/store/apps/details?id=bdo.trybe&hl=en', '_blank')
    }
  }

  renderSuccess = () => {
    return (
      <div className='coach-grant-access-container flex-column align-center flex-center'>
        <img src={require('../../images/confirmationCheckmark.png')} className='confirmation-checkmark' />

        <div className='confirmation-text'>Congrats! You've gotten access.</div>
        <div className='confirmation-text'>You're almost done. To finish,</div>

        <div className='steps-text'>1. Install Trybe.</div>

        <div className='app-store-images'>
          <img
            src={require('../../images/appStore.svg')}
            className='app-store-icon'
            onClick={ () => this.openNewTab.bind(this)('appStore') }
          />
          <img
            src={require('../../images/googlePlay.svg')}
            className='google-play-icon'
            onClick={ () => this.openNewTab.bind(this)('playStore') }
          />
        </div>

        <div className='steps-text'>2. Log in with the same credentials. Enjoy!</div>
      </div>
    )
  }

  renderLogin = () => {
    const showLock = this.state.profile ? false : true;
    const lockStyle = showLock ? 'flex-column' : 'flex-column lock-style-hidden'

    return (
      <div className={lockStyle}>
        <div className='title-text'>Get Access to your Coach's Programming</div>
        <div className='flex-row'>
          <div className='dot dot-active'></div>
          <div className='dot'></div>
        </div>
        <div className='steps-text extra-margin-bottom'>Sign up, or log in if you already have an account.</div>
        <div id='auth0-login-container' />
      </div>
    )
  }

  renderLoading = () => {
    return (
      <div className='flex-column'>
        <div className='steps-text'>One moment please...</div>
        <div className='loader'></div>
        <div className='steps-text'>Thanks for using Trybe.</div>
      </div>
    )
  }

  renderJoinError = () => {
    return (
      <div className='coach-grant-access-container flex-column align-center flex-center'>
        <div className='steps-text'>Uh oh, looks like there was an error signing up.</div>
        <div className='steps-text'>Please email support@trybe.do for assistance.</div>
      </div>
    )
  }


  render() {
    //always render loginView as auth0 logic requires it.
    //hide when not needed
    const loginView = this.renderLogin();

    let scene;
    if(this.state.isLoading){
      scene = this.renderLoading()
    } else if(this.props.athleteAccessResponse === 'Success'){
      scene = this.renderSuccess()
    } else if(this.props.athleteAccessResponse){
      scene = this.renderJoinError()
    }

    return (
      <div className='flex-column coach-grant-access-container '>
        { loginView }

        { scene }
      </div>
    );
  }
}

module.exports = CoachGrantAccess;



// WEBPACK FOOTER //
// ./src/components/signUp/CoachGrantAccess.js